import { allColors } from './colors';
import { fontSize, fontWeight, fontSizeMob } from './typography';
import { padding, margin, mobilePadding, mobileMargin } from './spacing';

import getTheme from '../index';

export const generateTheme = (
  theme = 'blue',
  fontFamily = 'Arial',
  isMobile
) => {
  let themeColor = theme.split('-');
  let color, gradient, darkMode;
  if (themeColor.length === 1) {
    color = themeColor[0] == 'default' ? 'skyblue' : themeColor[0];
  } else if (themeColor.length === 2) {
    color = themeColor[0];
    gradient = themeColor[1];
  } else {
    color = themeColor[0];
    gradient = themeColor[1];
    darkMode = themeColor[2];
  }

  console.log('color', allColors, gradient, darkMode);

  // switch (color) {
  //   case solidColors:
  //     break;

  //   case gradientColors:
  //     break;

  //   default:
  //     break;
  // }

  // type 1
  //   const solidColors = {
  //     font1: solidBaseColors?.black,
  //     font2: solidBaseColors?.black,
  //     font3: solidBaseColors?.black,
  //     font4: solidBaseColors?.black,
  //     AccentColor: solidBaseColors[theme],
  //     background1: solidBaseColors?.white,
  //     background2: solidBaseColors['tertiary' + theme],
  //     background3: solidBaseColors['tertiary' + theme],
  //     ctaColor: solidBaseColors[theme],
  //     CtaTextColor: solidBaseColors?.white,
  //     icon: solidBaseColors[theme],
  //     iconBg: solidBaseColors['tertiary' + theme],
  //     stripBg: solidBaseColors[theme],
  //     stripText: solidBaseColors?.white,
  //     inputBorderColor: solidBaseColors?.blue2,
  //     tertiaryBlue2: solidBaseColors?.tertiaryblue2
  //   };

  //type 2
  //   const gradientColors = {
  //     font1: gradientBaseColors?.white,
  //     font2: gradientBaseColors?.black,
  //     font3: gradientBaseColors?.black,
  //     font4: gradientBaseColors?.white,
  //     AccentColor: gradientBaseColors[theme],
  //     background1: gradientBaseColors[theme + 'gradient'],
  //     background2: gradientBaseColors['tertiary' + theme],
  //     background3: gradientBaseColors[theme + 'gradient'],
  //     ctaColor: gradientBaseColors[theme + 'gradient'],
  //     CtaTextColor: gradientBaseColors?.white,
  //     icon: gradientBaseColors[theme],
  //     iconBg: gradientBaseColors['tertiary' + theme],
  //     stripBg: gradientBaseColors?.black,
  //     stripText: gradientBaseColors?.white
  //   };

  const colors = {
    font1: gradient ? allColors?.white : allColors?.black,
    font2: darkMode ? allColors[color] : allColors?.black,
    font3: darkMode ? allColors?.white : allColors?.black,
    font4: darkMode
      ? allColors[color]
      : gradient
      ? allColors?.white
      : allColors?.black,
    AccentColor: allColors[color],
    background1: darkMode
      ? allColors?.lightblack
      : gradient
      ? allColors[color + 'gradient']
      : allColors?.white,
    background2: darkMode
      ? allColors?.lightblack
      : allColors['tertiary' + color],
    background3: darkMode
      ? allColors?.lightblack
      : gradient
      ? allColors[color + 'gradient']
      : allColors['tertiary' + color],
    ctaColor: darkMode
      ? allColors[color + 'gradient']
      : gradient
      ? allColors[color + 'gradient']
      : allColors[color],
    CtaTextColor: darkMode ? allColors?.lightblack : allColors?.white,
    icon: allColors[color],
    iconBg: darkMode ? allColors?.lightblack : allColors['tertiary' + color],
    stripBg: darkMode ? allColors[color + 'gradient'] : allColors?.black,
    stripText: darkMode ? allColors?.lightblack : allColors?.white,
    inputBorderColor: allColors?.blue2,
    tertiaryBlue2: allColors?.tertiaryblue2,
    white: allColors?.white,
    black: allColors?.black,
    lightblack: allColors?.lightblack,
    gray: allColors?.gray,
    bannerColor: darkMode
      ? allColors[color]
      : gradient
      ? allColors?.white
      : allColors?.bannerRed,
    bannerCtaColor: gradient ? allColors?.lightblack : allColors?.white,
    headerText: allColors[color],
    headerHover: allColors['tertiary' + color]
  };

  const typography = {
    fontFamily: `"${fontFamily}", "Roboto", "Helvetica", "Arial", "sans-serif"`,
    fontSize: isMobile ? fontSizeMob : fontSize,
    fontWeight
  };
  // const shape = { borderRadius };
  const spacing = {
    padding: isMobile ? mobilePadding : padding,
    margin: isMobile ? mobileMargin : margin
  };

  return {
    ...getTheme(theme),
    typography,
    spacing,
    colors
  };
};
